import { MAX_VALUE_ON_PRICE_RANGE, MIN_VALUE_ON_PRICE_RANGE } from '../../Constants';
import { RESULTS_SORT_OPTIONS } from '../../Constants';
import { toggleReduxArrayItem } from '../utils';
import {
  ADD_B_FILTERS,
  RESET_ALL_FILTERS,
  SET_PET_FRIENDLY_SELECTED,
  TOGGLE_B_FILTER,
  TOGGLE_PET_FRIENDLY_SELECTED,
  UPDATE_MAX_VALUE,
  UPDATE_MIN_VALUE,
  SET_RESULTS_APPLIED_SORT,
  ADD_N_FILTERS,
} from './action-types';

export const N_FILTERS_STATE_KEY = 'nFiltersStateArray';

const defaultState = {
  bFiltersStateArray: [],
  nFiltersStateArray: [],
  petFriendlySelected: false,
  rangeSliderMin: MIN_VALUE_ON_PRICE_RANGE,
  rangeSliderMax: MAX_VALUE_ON_PRICE_RANGE,
  resultsAppliedSort: RESULTS_SORT_OPTIONS[0],
};

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case RESET_ALL_FILTERS:
      return {
        ...state,
        ...defaultState,
      };
    case TOGGLE_B_FILTER: {
      const { bFiltersStateArray } = state;
      const value = action.payload;

      const newSelectedBFilters = toggleReduxArrayItem(bFiltersStateArray, value);

      return { ...state, bFiltersStateArray: newSelectedBFilters };
    }
    case ADD_B_FILTERS:
      return {
        ...state,
        bFiltersStateArray: [...new Set([...state.bFiltersStateArray, ...action.payload])],
      };
    case ADD_N_FILTERS:
      return {
        ...state,
        nFiltersStateArray: action.payload,
      };
    case TOGGLE_PET_FRIENDLY_SELECTED:
      return {
        ...state,
        petFriendlySelected: !state.petFriendlySelected,
      };
    case SET_PET_FRIENDLY_SELECTED:
      return {
        ...state,
        petFriendlySelected: action.payload,
      };
    case UPDATE_MAX_VALUE:
      return {
        ...state,
        rangeSliderMax: Math.min(action.payload, MAX_VALUE_ON_PRICE_RANGE),
      };
    case UPDATE_MIN_VALUE:
      return {
        ...state,
        rangeSliderMin: Math.max(action.payload, 0),
      }
    case SET_RESULTS_APPLIED_SORT:
      return {
        ...state,
        resultsAppliedSort: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
